import { FormatDistanceToNowOptions, formatDistanceToNow, isValid, parseISO } from 'date-fns';
import { getFormattedDateString } from './DateDisplay';
import { TextProps, Typography } from './Typography';

type GetFormattedDateToNowStringProps = {
  date: string;
  formatOptions?: FormatDistanceToNowOptions;
  nullOverride?: string;
  prefix?: string;
  suffix?: string;
};

export const getFormattedDateToNowString = ({
  date,
  formatOptions,
  nullOverride = '-',
  prefix = '',
  suffix = '',
}: GetFormattedDateToNowStringProps) => {
  const parsedDate = parseISO(date || '');
  const validDate = isValid(parsedDate);
  return validDate
    ? `${prefix}${formatDistanceToNow(parsedDate, { addSuffix: true, ...formatOptions })}${suffix}`
    : nullOverride;
};

type DateToNowProps = TextProps & GetFormattedDateToNowStringProps;

export const DateToNowDisplay = ({
  date,
  formatOptions,
  sx,
  prefix = '',
  suffix = '',
  nullOverride = '-',
  ...props
}: DateToNowProps) => {
  const formattedTooltip = getFormattedDateString({
    date,
    formatOverride: 'Pp',
    nullOverride,
    prefix,
    suffix,
  });
  const formattedDate = getFormattedDateToNowString({
    date,
    formatOptions,
    prefix,
    suffix,
  });
  return (
    <Typography
      noWrap
      fitContent
      handleOverFlow
      variant="body2"
      tooltip={formattedTooltip}
      tooltipProps={{ enterDelay: 500, enterNextDelay: 500 }}
      sx={{ ...sx }}
      {...props}
    >
      {formattedDate}
    </Typography>
  );
};
